/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Scope = {
    properties: {
        key: {
            type: 'ScopeEnum',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
